import { useTranslation } from 'react-i18next';
import Collapse from './Collapse';
import { ICON } from './DsRequest/icon';
import { Form, Input } from 'antd';

const { TextArea } = Input;

export default function CustomizeRights({ requestType = [], form }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language.toLocaleLowerCase();
    const formValue = form?.getFieldValue('rightDescriptionList');

    const getTitleName = (key) => {
        if (!key) return '';
        const find = requestType.find(
            (item) => item.requestTypeId === key.mdataSubjectRightId
        );
        return lang === 'th'
            ? 'สิทธิ' + find?.requestTypeShortName
            : find?.requestTypeNameEn;
    };

    return (
        <div>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Rights Details')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2">
                <Form.List name="rightDescriptionList">
                    {(fields) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => {
                                return (
                                    <Collapse
                                        key={key}
                                        icon={ICON.DOCUMENT}
                                        title={getTitleName(formValue[key])}
                                    >
                                        <div className="text-xs space-y-4">
                                            <Form.Item
                                                {...restField}
                                                label={t(
                                                    'Actions after the company receives the request',
                                                    { lang: 'TH' }
                                                )}
                                                name={[name, 'descriptionTh']}
                                            >
                                                <TextArea
                                                    rows={10}
                                                    placeholder={t(
                                                        'dataFlow.Description'
                                                    )}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                label={t(
                                                    'Actions after the company receives the request',
                                                    { lang: 'EN' }
                                                )}
                                                name={[name, 'descriptionEn']}
                                            >
                                                <TextArea
                                                    rows={10}
                                                    placeholder={t(
                                                        'dataFlow.Description'
                                                    )}
                                                />
                                            </Form.Item>
                                        </div>
                                    </Collapse>
                                );
                            })}
                        </>
                    )}
                </Form.List>
            </div>
        </div>
    );
}
